/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Pipe, PipeTransform} from '@angular/core';
import {ListWrapper} from '../facade/collection';
import {StringWrapper, isArray, isBlank, isString} from '../facade/lang';
import {InvalidPipeArgumentException} from './invalid_pipe_argument_exception';
export class SlicePipe implements PipeTransform {
  transform(value: any, start: number, end: number = null): any {
    if (isBlank(value)) return value;
    if (!this.supports(value)) {
      throw new InvalidPipeArgumentException(SlicePipe, value);
    }
    if (isString(value)) {
      return StringWrapper.slice(value, start, end);
    }
    return ListWrapper.slice(value, start, end);
  }

  private supports(obj: any): boolean { return isString(obj) || isArray(obj); }
/** @nocollapse */
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'slice', pure: false}, ] },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
